/**
 * 模块名称: 首页列表
 * @author xuzhongyuan@372163.com
 */

import React from 'react'
import { Table, Modal } from 'antd'
import { Link } from 'react-router-dom'
import api from '@/api'
import { scheduleObj, newsObj } from '@/utils/constant'
import { cryptoParamsIntoUrl } from '@/utils'

const { Column } = Table

const Module = ({ data, loading, onChange, getIndexData }) => {

  const onMouseDown = e => {
    e.currentTarget.classList.add('catching')
  }

  const onMouseUp = e => {
    e.currentTarget.classList.remove('catching')
  }

  const onDragStart = (e) => {
    e.dataTransfer.setData('id', e.target.getAttribute('data-id'))
  }

  const onDragOver = (e) => {
    e.preventDefault()
    const target = e.currentTarget
    clearCatching()
    if (target.className.indexOf('catching') === -1) {
      target.classList.add('catching')
    }
  }

  const clearCatching = () => {
    const modulesWrap = document.querySelector('.modules-wrap')
    const modules = modulesWrap.querySelectorAll('.module-item')
    for (let i = 0; i < modules.length; i++) {
      modules[i].classList.remove('catching')
    }
  }

  const onDrop = (e) => {
    e.preventDefault()
    clearCatching()
    const index1 = e.dataTransfer.getData('id')
    const index2 = e.currentTarget.getAttribute('data-id')
    if (index1 === index2) {
      return
    }
    // 1拖拽的元素 2被交换的元素
    onChange(+index1, +index2)
  }

  const renderTitle = () => {
    switch (data.moduleId) {
      case 1: case 2:
        return <h4 className="title">{data.moduleName}{!!data.unRead && <span className="un-read">{data.unRead > 99 ? '99+' : data.unRead}</span>}</h4>
      case 3: case 4: case 6:
        return <h4 className="title">{data.moduleName}{!!data.unRead && <span className="un-read-dot"></span>}</h4>
      default:
        return <h4 className="title">{data.moduleName}</h4>
    }
  }

  const onShowModal = (id, title) => {
    Modal.info({
      title: '消息内容',
      content: (
        <div>
          <p>{title}</p>
        </div>
      ),
      onOk() {
        api.setMessageReaded({ ids: [id] }).then(data => getIndexData())
      }
    })
  }

  const onSchedule = (title) => {
    Modal.info({
      title: '消息内容',
      content: (
        <div>
          <p>{title}</p>
        </div>
      ),
      onOk() {
      }
    })
  }

  return (
    <div
      className="module-item"
      draggable="true"
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      data-id={data.sort}
      id={`module_${data.sort}`}
    >
      <div className="module-title">
        {renderTitle()}
        {data.moduleId !== 5 && <Link to={(() => {
          switch (data.moduleId) {
            case 1:
              return '/message'
            case 2:
              return '/schedule'
            case 3:
              return '/notice'
            case 4:
              return '/regulation'
            case 6:
              return '/document'
          }
        })()}>更多</Link>}
      </div>
      {data.moduleId === 5
        ? <Table
          dataSource={data.dataList}
          rowKey="id"
          loading={loading}
          pagination={false}
          className="module-content"
        >
          <Column dataIndex="date" title="日期" />
          <Column dataIndex="signIn" title="签到" />
          <Column dataIndex="signOut" title="签退" />
          <Column dataIndex="ask_text" title="请假外出" />
          <Column dataIndex="long" title="时长" />
        </Table>
        : <Table
          dataSource={data.dataList}
          rowKey="id"
          loading={loading}
          pagination={false}
          className="module-content"
        >
          <Column 
            dataIndex="title" 
            title="标题" 
            width="55%" 
            ellipsis={true} 
            render={(text, record) => {
              switch (data.moduleId) {
                case 1:
                  if (text === "您的审核需要补充资料" && record.type === 12) { // 系统消息 (补充资料) 发票
                    return <Link to={`/protocol/invoice/apply?id=${record.targetId}&msgId=${record.id}`}>{text}</Link>
                  } else {
                    return newsObj[record.type] ? (
                      <Link
                        to={
                          [27, 64, 65, 66, 67, 71, 72, 73, 74, 75].includes(record.type)
                            ? newsObj[record.type]
                            : cryptoParamsIntoUrl(newsObj[record.type], { id: record.targetId, msgId: record.id })
                        }
                      >
                        {text}
                      </Link>
                    ) : (
                      <div onClick={() => onShowModal(record.id, text)}>{text}</div>
                    )                  
                  }
                case 2:
                  return scheduleObj[record.type] ?
                    <Link to={
                      [53, 54, 55, 56, 60, 61, 62, 63, 64].includes(record.type)
                        ? scheduleObj[record.type]
                        : cryptoParamsIntoUrl(scheduleObj[record.type], { id: record.targetId })
                    }>
                      {record.type == 15 ? `[${record.applyUser.name}] ${text}` : text}
                    </Link>
                    :
                    <div onClick={() => onSchedule(text)}>{record.type == 15 ? `[${record.applyUser.name}] ${text} ` : text}</div>
                case 3:
                  return <Link to={cryptoParamsIntoUrl('/notice/details', { id: record.id })}>{text}</Link>
                case 4:
                  return <Link to={cryptoParamsIntoUrl('/regulation/details', { id: record.id })}>{text}</Link>
                case 6:
                  return <Link to={cryptoParamsIntoUrl('/document/details', { id: record.id })}>{text}</Link>
                default:
                  return text
              }
            }} 
          />
          {data.moduleId == 2 && <Column dataIndex="applyUser.name" title="申请人" ellipsis={true} width="20%" />}
          <Column dataIndex="addTime" title="创建时间" ellipsis={true} width="25%" />
        </Table>
      }
    </div>
  )
}

export default Module
